module.exports = __webpack_public_path__ + "img/KW.166e4bd8.png";